import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { BenefitCard, SwiperController } from '../../basic';
SwiperCore.use([Pagination]);
const SwiperComponent = (props) => {
    const { data, visible } = props;
    const [chunkSize] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const swiperRefDesktop = useRef(null);
    const benefitChunks = [];
    if (!data || !visible)
        return null;
    for (let i = 0; i < data.length; i += chunkSize) {
        benefitChunks.push(data.slice(i, i + chunkSize));
    }
    const totalPage = Math.ceil(data.length / chunkSize);
    const onNext = () => {
        if (currentPage < totalPage) {
            setCurrentPage(currentPage + 1);
            swiperRefDesktop.current.swiper.slideNext();
        }
    };
    const onPrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            swiperRefDesktop.current.swiper.slidePrev();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Swiper, { ref: swiperRefDesktop, slidesPerView: 1, centeredSlides: true, spaceBetween: 30, modules: [Pagination], className: "benefit-swiper-desktop", onSlideChange: (swiper) => setCurrentPage(swiper.activeIndex + 1), initialSlide: currentPage - 1, children: benefitChunks.map((chunk, index) => (_jsx(SwiperSlide, { children: _jsx("div", { style: { display: 'flex', justifyContent: 'space-between', gap: '16px' }, children: chunk.map((benefitCard, innerIndex) => (_jsx("div", { children: _jsx(BenefitCard, { image: benefitCard.image, label: benefitCard.label, index: innerIndex }) }, `benefit_card_${index}_${innerIndex}`))) }) }, `swiper_slide_${index}`))) }), data.length > 5 &&
                _jsx(SwiperController, { currentPage: currentPage, totalPage: totalPage, onNext: onNext, onPrev: onPrev })] }));
};
export default SwiperComponent;
